import React from 'react';
import DocumentPicker from '../../DocumentPicker/DocumentPicker';

const DocumentsTab = React.memo(({ 
  clinicId, 
  openDocs, 
  onGenerateDocument 
}) => {
  const excludeTemplateIds = openDocs.map((d) => d.template_id);
  
  return (
    <div className="documents-subtab">
      <DocumentPicker
        clinicId={clinicId}
        excludeTemplateIds={excludeTemplateIds}
        onGenerate={onGenerateDocument}
      />
    </div>
  );
});

DocumentsTab.displayName = 'DocumentsTab';

export default DocumentsTab;